import { useState } from "react";
import wmPeople from "@/assets/pik-wordmark-people.png";
import wmKnow from "@/assets/pik-wordmark-know.png";
import wmIMask from "@/assets/pik-wordmark-i-mask.png";

const COLORS = [
  "#ec4899",
  "#f59e0b",
  "#10b981",
  "#8b5cf6",
  "#06b6d4",
  "#1d4ed8",
  "#ef4444",
];

export const PikWordmark = () => {
  const [color] = useState(
    () => COLORS[Math.floor(Math.random() * COLORS.length)],
  );
  const mask = `url(${wmIMask})`;
  return (
    <span
      data-testid="pik-wordmark"
      role="img"
      aria-label="peopleiknow"
      className="inline-flex h-[3.15em] translate-y-[0.5em] items-center"
    >
      <img
        src={wmPeople}
        alt=""
        aria-hidden
        style={{ aspectRatio: "320/129" }}
        className="h-full w-auto shrink-0"
      />
      <span
        data-testid="pik-wordmark-i"
        aria-hidden
        className="h-full shrink-0"
        style={{
          aspectRatio: "34/129",
          backgroundColor: color,
          WebkitMaskImage: mask,
          maskImage: mask,
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
        }}
      />
      <img
        src={wmKnow}
        alt=""
        aria-hidden
        style={{ aspectRatio: "241/129" }}
        className="h-full w-auto shrink-0"
      />
    </span>
  );
};
